import cookie from "js-cookie";

const expires = 3600 * 1000 * 24 * 365 * 10;

export const setAuthCoookies = (data: any, secure: boolean = false) => {

    for (let key in data) {      
        if (data.hasOwnProperty(key)){
            cookie.set(key, data[key], { expires, secure });
        }
    }

    cookie.set("user", JSON.stringify(data));
    
};
